import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import PageTitle from 'components/page-title';
import TypesTab from './components/types-tab';
import RecordsTab from './components/records-tab';
import WaivesTab from './components/waives-tab';

const TAB_KEYS = ['records', 'waives', 'types'];

const StarPenaltiesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'records';
  const activeKey = TAB_KEYS.includes(tab) ? tab : 'records';

  return (
    <div>
      <PageTitle title="Phạt & xoá phạt" />
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setSearchParams(key === 'records' ? {} : { tab: key })}
        destroyInactiveTabPane
        items={[
          { key: 'records', label: 'Bản ghi phạt', children: <RecordsTab /> },
          { key: 'waives', label: 'Chờ duyệt xoá phạt', children: <WaivesTab /> },
          { key: 'types', label: 'Loại phạt', children: <TypesTab /> },
        ]}
      />
    </div>
  );
};

export default StarPenaltiesPage;
